import { isoStringToDate } from '@/common/filters';
import { ObjectsType } from '@/store/application/data.assets';
import intersection from 'lodash/intersection';
import { featuresModule } from '../features';
import { fixLineCrossingDirection } from '@/store/events/utils';
import { isDefined } from '@/definitions/services/helpers';

export function satisfyEventFilter(event: any, filter: any, objects: ObjectsType): boolean {
  let satisfy = true;

  if (satisfy && filter.id) {
    satisfy = filter.id === event.id;
  }

  if (satisfy && filter.id_in) {
    const id = String(event.id);
    satisfy = Array.isArray(filter.id_in) ? (filter.id_in.length ? filter.id_in.includes(id) : true) : String(filter.id_in) === id;
  }

  if (satisfy && filter.episode) {
    satisfy = String(filter.episode) === String(event.episode);
  }

  if (satisfy && filter.matched_card_in) {
    satisfy = satisfyListOrSingleFilterNumber(filter.matched_card_in, event.matched_card);
  }

  if (satisfy && filter.acknowledged) {
    satisfy = filter.acknowledged === 'True' ? event.acknowledged : !event.acknowledged;
  }

  if (satisfy && filter.no_match) {
    satisfy = filter.no_match === 'True' ? !event.matched_card : !!event.matched_card;
  }

  if (satisfy && filter.matched_lists.length) {
    satisfy = intersection(filter.matched_lists, event.matched_lists).length > 0;
  }

  if (satisfy && filter.camera_groups.length) {
    satisfy = filter.camera_groups.find((v: number) => v === event.camera_group);
  }

  if (satisfy && filter.cameras.length) {
    satisfy = !!filter.cameras.find((v: number) => v === event.camera);
  }

  if (satisfy && filter.created_date_gte) {
    let filterGTEDate = isoStringToDate(filter.created_date_gte),
      eventDate = isoStringToDate(event.created_date);

    satisfy = eventDate.getTime() >= filterGTEDate.getTime();
  }

  if (satisfy && filter.created_date_lte) {
    let filterLteDate = isoStringToDate(filter.created_date_lte),
      eventDate = isoStringToDate(event.created_date);
    satisfy = eventDate.getTime() <= filterLteDate.getTime();
  }

  if (satisfy && filter.video_archive) {
    satisfy = satisfyListOrSingleFilterNumber(filter.video_archive, event.video_archive);
  }

  if (satisfy && filter.bs_type) {
    satisfy = filter.bs_type === event.bs_type;
  }

  if (satisfy && filter.line) {
    satisfy = satisfyListOrSingleFilterNumber(filter.line, event.line);
  }

  if (satisfy && filter.line_crossing_direction) {
    satisfy = satisfyListOrSingleFilterString(filter.line_crossing_direction, fixLineCrossingDirection(event.line_crossing_direction));
  }

  if (satisfy && filter.backward_line_crossing) {
    satisfy = filter.backward_line_crossing === 'True' ? event.backward_line_crossing : !event.backward_line_crossing;
  }

  if (satisfy && isDefined(filter.local)) {
    satisfy = filter.local ? event.local : !event.local;
  }

  satisfy = satisfy && featuresModule.satisfyFeaturePropsToFilters(event.features, filter, objects);
  return satisfy;
}

export function satisfyListOrSingleFilterNumber(filter: number[] | number, value: number) {
  return Array.isArray(filter) ? filter.length === 0 || filter.map((v) => Number(v)).includes(value) : Number(filter) === value;
}

export function satisfyListOrSingleFilterString(filter: string[] | string, value: string) {
  return Array.isArray(filter) ? filter.length === 0 || filter.includes(value) : String(filter) === value;
}
